import AiGradientSpinner from '@cobliteam/ui-business/components/AiGradientSpinner';

const GRADIENT = 'linear-gradient(135deg, #001BB8 0%, #9847EE 100%)';
const BORDER_GRADIENT = 'linear-gradient(90deg, #001BB8 0%, #9847EE 100%)';

const AiRecommendationTaskPopoverSkeleton = () => (
  <div className='p-3'>
    <div
      className='flex w-full flex-col items-center justify-center gap-4 rounded-xl py-12'
      style={{
        background: '#F8F7FD',
        border: '1px solid transparent',
        backgroundImage: `linear-gradient(#F8F7FD, #F8F7FD), ${BORDER_GRADIENT}`,
        backgroundOrigin: 'border-box',
        backgroundClip: 'padding-box, border-box',
        minHeight: '260px',
      }}
    >
      <AiGradientSpinner size='lg' />

      {/* Text */}
      <div className='flex flex-col items-center gap-1'>
        <span className='font-semibold text-base' style={{ background: GRADIENT, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
          Analisando sua frota com IA
        </span>
        <span className='text-neutral-400 text-sm'>Isso pode levar alguns segundos...</span>
      </div>
    </div>
  </div>
);

export default AiRecommendationTaskPopoverSkeleton;
